import { useState } from "react";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Popover, Tooltip } from "@mui/material";

import MenuButton from "../MenuButton";

const EmojiPickerPopover = ({ editor }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	// Version 1 emoji set
	// 1-4 Reactions, 5-8 Status, 9-12 Appointments
	const emojis = [
		{ emoji: "😀", name: "Smile" },
		{ emoji: "😂", name: "Joy" },
		{ emoji: "👎", name: "Deny" },
		{ emoji: "👍", name: "Approve" },
		{ emoji: "👀", name: "Eyes" },
		{ emoji: "⚠️", name: "Warning" },
		{ emoji: "🚫", name: "Prohibited" },
		{ emoji: "✅", name: "Check" },
		{ emoji: "⭐", name: "Star" },
		{ emoji: "💰", name: "Cash" },
		{ emoji: "💳", name: "Card" },
		{ emoji: "📅", name: "Appointment" },
	];

	const insertEmoji = (emoji) => {
		if (!editor) return;
		editor.chain().focus().insertContent(emoji).run();
		handleClose();
	};

	return (
		<>
			<Tooltip title="Insert Emoji">
				<Box sx={{ 
					display: "flex", 
					alignItems: "center",
					mr: 1
				}}>
					<MenuButton 
						onClick={handleOpen}
						sx={{ display: "flex", alignItems: "center", pr: 0.5 }}
					>
						<EmojiEmotionsIcon fontSize="small" />
						<ExpandMoreIcon fontSize="small" sx={{ ml: 0.5 }} />
					</MenuButton>
				</Box>
			</Tooltip>

			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}

				slotProps={{
					paper: {
						sx: { 
							padding: "8px",
							overflow: "hidden"
						}
					}
				}}
			>
				<Box
					sx={{ 
						display: "flex", 
						flexWrap: "wrap",
						width: "192px", // 4 emojis per row
						m: "-4px", // Compensate for child margins
					}}
				>
					{emojis.map(({ emoji, name }) => (
						<Box
							key={emoji} 
							sx={{ 
								width: 40,
								height: 40,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
								fontSize: "24px",
								borderRadius: "4px",
								m: "4px",
								"&:hover": {
									backgroundColor: "rgba(0,0,0,0.04)"
								},
								"&:focus": {
									outline: "2px solid #1976d2",
									outlineOffset: "2px"
								}
							}} 
							onClick={() => insertEmoji(emoji)}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									insertEmoji(emoji);
								}
							}}
						>
							{emoji}
						</Box>
					))}
				</Box>
			</Popover>
		</>
	);
};

export default EmojiPickerPopover;